// import $, { event } from "jquery"
// window.jQuery = $
// window.$ = $

// PLUGINS======================================================================================
import Inputmask from "inputmask"
// import "@fancyapps/fancybox"
import LazyLoad from "vanilla-lazyload"

// MODULES======================================================================================
// import "./js-modules/sliders.js"

import initTabs from "./js-modules/tabs"
// import initDropdowns from './js-modules/dropdowns'
// import initPopup from "./js-modules/popup";
import initAnimations from "./js-modules/animations"
// import initShowmore from "./js-modules/showmore"
// import initMobilemenu from "./js-modules/mobilemenu"

// init ========================================================================================
document.addEventListener("DOMContentLoaded", () => {
    let lazyload = new LazyLoad()
    // $("[data-fancybox]").fancybox({
    //     smallBtn: true,
    //     touch: false,
    //     btnTpl: {
    //         smallBtn: `<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
    //                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                         <rect y="19.5122" width="27.5944" height="0.68986" transform="rotate(-45 0 19.5122)" fill="white" />
    //                         <rect x="0.487793" width="27.5944" height="0.68986" transform="rotate(45 0.487793 0)" fill="white" />
    //                     </svg>
    //                    </button>`,
    //     },
    // })
    // $.fancybox.defaults.backFocus = false
    let im = new Inputmask("+7 (999) 999-99-99")
    im.mask(document.querySelectorAll('input[type="tel"]'))
    // initShowmore()
    // initDropdowns()
    // initPopup()
    initTabs()
    // initMobilemenu()
    initAnimations()
    
})
